import React from 'react';
import '../styles/PrivacyPolicyPage.css';

const PrivacyPolicyPage = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date: May 16, 2026</strong></p>

      <p>
        This Privacy Policy describes the practices of Dubbah Inc. ("Dubbah," "we," "us," or "our")
        regarding information collected through (1) the Dubbah desktop application (the "App") and
        (2) the dubbah.co website (the "Website"). We are committed to transparency about what we
        do and do not collect.
      </p>

      <h2>Part 1: Dubbah Desktop App</h2>

      <h3>No Data Collection</h3>
      <p>
        The Dubbah desktop application does not collect, transmit, or store any user data on external
        servers. All processing happens entirely on your machine. Specifically:
      </p>
      <ul>
        <li>Your video and audio files never leave your device.</li>
        <li>Translations and voice synthesis are performed locally using on-device AI models.</li>
        <li>We do not collect personal identifiers, usage analytics, crash reports, or telemetry of any kind.</li>
        <li>The App does not contain any tracking SDKs, advertising frameworks, or analytics software.</li>
        <li>Your content is never used to train AI models.</li>
      </ul>

      <h3>Network Communication</h3>
      <p>
        The App may connect to the internet solely to download or update AI models during initial setup.
        This does not involve any transmission of personal data or user content.
      </p>

      <h3>Data Security</h3>
      <p>
        Since all data remains on your device, its security is governed by your operating system and
        your own device security practices. Dubbah does not have access to any data stored on your machine.
      </p>

      <h2>Part 2: dubbah.co Website</h2>

      <h3>Information We Collect</h3>
      <p>
        When you visit dubbah.co, we collect certain information to understand how visitors use our site
        and to improve our marketing:
      </p>
      <ul>
        <li>
          <strong>Analytics (Google Analytics):</strong> We use Google Analytics to collect anonymized
          usage data such as pages visited, time on site, and referral sources. This data is aggregated
          and does not personally identify you.
        </li>
        <li>
          <strong>Visitor Identification (RB2B):</strong> When you visit or log in to our website,
          cookies and similar technologies may be used by our online data partners or vendors to
          associate these activities with other personal information they or others have about you,
          including by association with your email. We (or service providers on our behalf) may then
          send communications and marketing to these email addresses. You may opt out of receiving
          this advertising by visiting <a href="https://app.retention.com/optout">https://app.retention.com/optout</a>.
        </li>
        <li>
          <strong>Contact Form:</strong> If you submit our contact form, we collect your email address
          and message to respond to your inquiry. This information is stored securely and is not shared
          with third parties.
        </li>
      </ul>

      <h3>Cookies</h3>
      <p>
        The Website uses cookies for analytics and visitor identification as described above. You can
        manage cookie preferences through your browser settings.
      </p>

      <h3>International Visitors</h3>
      <p>
        If you are visiting from outside the United States, please note that your data may be processed
        in the United States. If you are located in the European Economic Area, you also have the option
        to opt out of the collection of your personal data in compliance with GDPR by
        visiting <a href="https://www.rb2b.com/rb2b-gdpr-opt-out">https://www.rb2b.com/rb2b-gdpr-opt-out</a>.
      </p>

      <h2>Part 3: General</h2>

      <h3>Changes to This Policy</h3>
      <p>
        We may update this Privacy Policy from time to time. Changes will be reflected by updating
        the "Effective Date" at the top of this page. Your continued use of the App or Website after
        changes constitutes acceptance of the updated policy.
      </p>

      <h3>Contact</h3>
      <p>
        If you have questions about this Privacy Policy, contact us at coleman@dubbah.co.
      </p>
    </div>
  );
};

export default PrivacyPolicyPage;
